<template>
  <v-app id="inspire">
    
    <Loading v-if="loading" />

    <v-content v-else>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card
              class="mx-auto elevation-10"
              max-width="344"
            >
            <v-img
              class="my-5 pt-5"
              aspect-ratio="2"
              :src="require('@/assets/images/logo2.png')"
              contain
              height="300px"
            ></v-img>

  

    <v-container>

          <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    
        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="Correo"
          required
        ></v-text-field>


         <v-text-field
            v-model="password"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="show2 ? 'text' : 'password'"
            name="input-10-2"
            label="Clave"
            hint="At least 8 characters"
            value=""
            class="input-group--focused"
            @click:append="show2 = !show2"
          ></v-text-field>


    <v-row  
      align="center"
      justify="center"
    >
    <v-col 
        class="d-flex"
      >

    

    <v-btn
      color="primary"
      @click="log"
      block
      large
      :disabled="email == '' || password == ''" 
      
    >
    
      Ingresar
      <v-icon left class="ml-1">mdi-login</v-icon>
    </v-btn>

    
 

    </v-col>
    </v-row>

    
  </v-form>

    </v-container>

    

  </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    
  </v-app>
</template>

  <script>

  import {login} from '../../services/auth/authenticate'
  import Loading from '../dashboard/component/helpers/loading'

  export default {

    components:{
      Loading
    },

    data: () => ({

       show1: false,
        show2: false,
        show3: false,
        show4: false,
        password: 'Password',
        rules: {
          required: value => !!value || 'Este campo es requerido',
          min: v => v.length >= 6 || 'tiene que tener minimo de 6 digitos',
          emailMatch: () => ('The email and password you entered don\'t match'),
        },

      valid: true,
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      password:'',
      emailRules: [
        v => !!v || 'El correo es requerido',
        v => /.+@.+\..+/.test(v) || 'Este es un email incorrecto',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      checkbox: false,
    }),

    computed: {
      loading(){

        return this.$store.state.loading

      }
    },

    methods: {

      log:function(){
        this.$store.commit("loading_mutation");
        login({email:this.email, password:this.password}).then(response=>{
          //console.log(response);
          this.$store.commit("loginSuccess", response);
          this.$router.push({ path: "/" });
          this.$toastr.success(`Hola ${response.user.name}`, 'Login exitoso');
        }).catch(errors=>{
          this.$store.commit("loginFailed", { errors });
          this.$toastr.error(errors);
          //console.log(errors);
        });

      },

      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>
